import React, { useState, useEffect } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, ContentState, convertFromHTML, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import { Button, Icon, Modal } from 'semantic-ui-react';
import i18next from 'i18next';
import api from '../../../actions/api';

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import './ReceiptAppendixEditor.scss';

function ReceiptAppendixEditor({ onClose, restaurantId }) {
    const [editorState, setEditorState] = useState(() => EditorState.createEmpty());

    useEffect(() => {
        if (restaurantId) {
            api.restaurant.get(restaurantId).receipt.getConfig()
                .then(({ data }) => {
                    if (data && data.appendix) {
                        const blocksFromHTML = convertFromHTML(data.appendix);
                        const state = ContentState.createFromBlockArray(
                            blocksFromHTML.contentBlocks,
                            blocksFromHTML.entityMap,
                        );
                        setEditorState(EditorState.createWithContent(state));
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        }
    }, [restaurantId]);

    function handleSave() {
        const html = draftToHtml(convertToRaw(editorState.getCurrentContent()));
        api.restaurant.get(restaurantId).receipt.setConfig({ appendix: html })
            .then(html => onClose())
            .catch(err => alert('failed to save'));
    }

    return (
        <Modal open>
            <Modal.Header>{i18next.t('receiptConfig')}</Modal.Header>
            <Modal.Content scrolling>
                <Editor
                    editorState={editorState}
                    editorClassName="receipt-appendix-editor ui segment"
                    onEditorStateChange={setEditorState}
                />
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={onClose}>
                    {i18next.t('close')} <Icon name='close' />
                </Button>
                <Button primary onClick={handleSave}>
                    {i18next.t('save')} <Icon name='save' />
                </Button>
            </Modal.Actions>
        </Modal>
    );
}

export default ReceiptAppendixEditor;

const html = `
<p><br>
<ins><strong>מדיניות החזרת מוצרים</strong></ins><br>
</p>
<ul>
  <li>זיכוי/החלפת מוצרים,(למעט מוצרים של חב' אנרג'ם בע"מ, כמפורט להלן) בצירוף חשבונית או פתק החלפה בלבד, עד 30 יום מתאריך הרכישה ובלבד שהמוצרים לא נפתחו ו/או לא נפגמו (המוצר ו/או האריזה) ושלא נעשה בהם כל שימוש.</li>
  <li>על אף האמור לעיל, זיכוי/החלפת מוצרים, של מוצרים מבית חב' אנרג'ם בע"מ בצירוף חשבונית או פתק החלפה בלבד, עד14 יום מתאריך הרכישה ובלבד שהמוצרים לא נפתחו ו/או לא נפגמו (המוצר ו/או האריזה) ושלא נעשה בהם כל שימוש.</li>
  <li>סכום שובר הזיכוי יהיה זהה לסכום הקנייה בפועל הנקוב על גבי החשבונית.</li>
  <li>לא ניתן להחליף או לקבל זיכוי על בגדי ים והלבשה תחתונה ועל מוצרים שנרכשו בחנויות בחו"ל.</li>
  <li>החזרת/החלפת פריטי עודפים תתאפשר ברשת עודפים בלבד, בצירוף חשבונית או פתק החלפה עד 21 יום מתאריך הרכישה.</li>
  <li>מוצרים שנרכשו בתנאי "מכירה מיוחדת" (למשל 1+1, 3 ב-100 ₪) יוחזרו על פי אותם תנאי הרכישה (בהחזרה של כל המוצרים), ככל שיוחזרו רק חלק מהמוצרים ,החזר הכספי ו/או הזיכוי )לפי העניין) יינתן בהתאם לשיעור ההנחה היחסי שניתן בפועל בגין המוצר, בעת הרכישה.</li>
  <li>מוצר שנרכש באילת והוחזר/ הוחלף ביתר אזורי הארץ, ייעשו בהתאם למגבלות חוק המע"מ ויהיו כרוכים בתשלום מע"מ.</li>
  <li>לא תתאפשר החלפה ו/או קבלת זיכוי של מוצר שנרכש מחוץ לאילת ובאילת (בהתאמה).</li>
  <li>ניתן לרכוש עד 10 פריטים ללקוח.</li>
  <li>במכירה של דגמי השקה, יימכר פריט אחד ללקוח בלבד.</li>
</ul>
<p><ins><strong>ביטול/החזר כספי</strong></ins><br>
</p>
<ul>
  <li>ביטול עסקה וקבלת החזר כספי ייעשה בהתאם לתקנות . הגנת הצרכן (ביטול עסקה), תשכ"א – 2010.</li>
  <li>לא תחול זכות הביטול על מוצרים שנרכשו בתווי קנייה, שובר מתנה, זיכוי או כרטיס מגנטי נטען.</li>
  <li>החזר כספי בגין ביגוד והנעלה יינתן עד 2 ימי עסקים.</li>
</ul>
<p><ins><strong>אחריות מוצרים של חב' אנרג'ים בע"מ</strong></ins></p>
<ul>
  <li>אחריות בגין מוצרים של חב' אנרג'ים בע"מ, תינתן בכפוף להוראות תעודת האחריות המצורפת למוצרים.</li>
</ul>
`;
